import { Login } from '@/pages/Login';
import { InteractionType } from '@azure/msal-browser';
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { LanguageProvider } from '@data-products-and-ai/react-components';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';
import { CONSTANTS } from './constants/constants';
import { Simulation } from './pages/Simulation';
import { store } from './store';
import { ToastProvider } from '@/contexts/Toast/ToastContext';

/**
 * App Component
 * Root of the application
 * Configures routing and authentication templates
 * Includes global providers for toast notifications and language translations
 * Handles authenticated and unauthenticated states
 * Displays a not found page for undefined routes
 */
function App() {
  const NotFoundPage = () => {
    return <>Not found</>;
  };

  const Main = () => (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <Simulation />
    </MsalAuthenticationTemplate>
  );

  const LoginToggle = () => {
    return (
      <>
        <ToastProvider>
        <LanguageProvider translations={CONSTANTS} defaultLanguage="en">
          <AuthenticatedTemplate>
            <StoreProvider store={store}>
              <Main />
            </StoreProvider>
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
            <Login />
          </UnauthenticatedTemplate>
        </LanguageProvider>
        </ToastProvider>
      </>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/notfound" element={<NotFoundPage />} />
        <Route path="*" element={<LoginToggle />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
